import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { Site } from '@portal-core/sites/models/site.model';

@CollectionStateSelectors({
  stateType: SitesState
})
@State<SitesState>({
  name: SitesState.source,
})
@Injectable()
export class SitesState extends CollectionStateBase {
  static source = 'Sites';
  getSource(): string {
    return SitesState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SitesDataService extends CollectionDataServiceBase<Site> {
  constructor(protected store: Store) {
    super(store, SitesState);
   }
}
